// extracted by mini-css-extract-plugin
export default {"root":"root--y1iVO","warning":"warning--_t0kV","icon":"icon--jfLGG","text":"text--Gkx__"};